const InfoData = {
    contacts: [
        {
            icon: ["fas", "square-envelope"],
            url: "mailto:winghtse5@gmail.com",
            text: "winghtse5@gmail.com"
        },
        {
            icon: ["fas", "square-phone"],
            url: "tel:+85266434472",
            text: "+852 6643 4472"
        },
        {
            icon: ["fab", "linkedin"],
            url: "https://www.linkedin.com/in/jarvis-tse",
            text: "Visit My Linkedin"
        },
        {
            icon: ["fab", "github"],
            url: "https://github.com/jarvistse5",
            text: "Visit My Github"
        },
        {
            icon: ["fas", "file-pdf"],
            file: "assets/files/jarvis_tse_cv.pdf",
            text: "View My Resume"
        }
    ],
    skills:[
        'HTML', 'CSS', 'JavaScript', 'PHP', 'Laravel',
        'Docker', 'AWS', 'Bootstrap', 'Java', 'Spring Boot', 'React.js', 'React Native',
        'TailwindCSS', 'Python', 'C++', 'Angular', 'MySQL', 'RDBMS', 'Git',
        'Redis', 'Nginx', 'Apache', 'jQuery', 'Django', 'OAuth', 'WebSocket', 'JMeter',
        'RESTful API', 'OOP', 'MVC', 'Agile', 'Node.js', 'Next.js',
        'MarkLogic', 'GraphQL', 'DGraph', 'Oracle Database', 'Power BI', 'PeopleSoft',
        'UiPath', 'Power Automate', 'Microsoft Copilot Studio'
    ],
    skillRate: [
        {
            category: "Frontend",
            skills: [
                {
                    name: "HTML, CSS, JavaScript",
                    value: 1.0
                },
                {
                    name: "TypeScript, React.js",
                    value: 0.8
                },
                {
                    name: "Angular",
                    value: 0.6
                },
                {
                    name: "React Native",
                    value: 0.4
                },
            ]
        },
        {
            "category": "Backend",
            "skills": [
                {
                    name: "Node.js, Next.js",
                    value: 0.8
                },
                {
                    name: "MySQL, RDBMS",
                    value: 0.8
                },
                {   
                    name: "Java, Spring Boot",
                    value: 0.6
                },
                {
                    name: "PHP, Laravel",
                    value: 0.6
                }
            ]
        },
        {
            category: "Others",
            skills: [
                {
                    name: "Linux",
                    value: 0.8
                },
                {
                    name: "Docker",
                    value: 0.6
                },
                {
                    name: "AWS",
                    value: 0.4
                },
                {
                    name: "CI/CD",
                    value: 0.2
                }
            ]
        }
    ],
    education: [
        {
            name: 'The Hong Kong University of Science and Technology',
            description: 'Bachelor of Engineering in Computer Engineering with Second Class Honors Division I',
            period_start: '09/2017',
            period_end: '11/2020',
        },
        {
            name: 'Community College of City University',
            description: 'Associate of Engineering with Credit',
            period_start: '09/2015',
            period_end: '07/2017',
        }
    ],
    experience: [
        {
            title: 'Systems Analyst',
            company: 'Hong Kong Metropolitan University',
            period_start: '10/2025',
            period_end: 'Current',
            location: 'Hong Kong',
            description: [
                'Manage end-to-end delivery of web-related projects, collaborating with internal stakeholders, vendors, and service providers to define requirements, govern timelines, and ensure successful deployment.',
                'Design, develop, and maintain Robotic Process Automation (RPA) workflows and Copilot-based agents to deliver over 10 automation and AI-driven workflow solutions.',
                'Analyze, enhance, and support existing web platforms, implementing improvements to performance, usability, and reliability while providing ongoing technical support.'
            ]
        },
        {
            title: 'Application Programmer Analyst',
            company: 'University of Toronto',
            period_start: '09/2023',
            period_end: '02/2025',
            location: 'Toronto',
            description: [
                'Maintained and improved Canada\'s largest academic library system, with 40 libraries across 3 campuses, 1.5 petabytes of digital storage, and 10.5 terabytes of archived web content.',
                'Modernized several legacy web applications in outdated stacks to modern ones, and provided user support with bug fixes and feature updates.',
                'Participated in developing a digital collection system, managing over 250,000 digitized objects. Integrated the system with the International Image Interoperability Framework (IIIF) and standardized the collection with metadata formats.'
            ]
        },
        {
            title: 'Full Stack Developer',
            company: 'EPISODE Limited',
            period_start: '03/2022',
            period_end: '02/2023',
            location: 'Hong Kong',
            description: [
                'Designed and implemented a virtual event platform from scratch to host online conferences and virtual exhibitions. The platform includes different interactive features such as AR, chat rooms, live streaming, polling, and Q&A.',
                'Maintained an all-in-one event system, including registration, email, check-in, and name badge printing. Provided real-time technical support for every project.',
                'Provided customized IT solutions and developed new event technologies, such as AR-based interactive events, AI-powered face swap features.'
            ],
        },
        {
            title: 'Web Developer',
            company: 'Impacts Technology Limited',
            period_start: '10/2020',
            period_end: '12/2021',
            location: 'Hong Kong',
            description: [
                'Worked at the E-Learning Development Laboratory of The University of Hong Kong and maintained the e-learning platforms iClass and iTrain.',
                'Built tailor-made, professional, and comprehensive cloud-based corporate training solutions for both online self-directed learning and face-to-face interactive training.',
                'Converted the e-learning platform into a B2C/B2B2C model and implemented a payment and subscription policy using Stripe.'
            ],
        },
        {
            title: 'Programmer',
            company: 'Fortune Information Technology Limited',
            period_start: '06/2019',
            period_end: '08/2019',
            location: 'Hong Kong',
            description: [
                'Researched and developed an AI-based speech-to-text engine and embedded it into computer telephony integration.',
                'Collaborated with clients\' tech team to upgrade the enterprise management system.',
                'Participated in website development, including coding simple features, testing, and fixing bugs.'
            ],
        }
    ],
    projects: [
        {
            name: '3D Book Binding Visualization Prototype',
            description: 'The prototype is designed to allow users to build/manipulate a codex in a 3D space, which can be used to visualize the binding process of a book. Website: https://obns.library.utoronto.ca/codex/',
            skills: [
                'React.js', 'Three.js', 'Node.js', 'Angular', 'MarkLogic', 'GraphQL'
            ],
            cover_img: 'assets/images/projects/cover/book-silk-road.png',
            assets: [
                {
                    type: 'youtube',
                    youtube_id: 'lwA_fjXDTKM',
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/book-silk-road/01_codex_demo_1.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/book-silk-road/02_codex_demo_2.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/book-silk-road/03_codex_demo_3.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/book-silk-road/04_admin_home.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/book-silk-road/05_admin_book_edit.png'
                },
            ]
        },
        {
            name: 'Hidden Stories',
            description: 'Hidden Stories connects over 130 collaborators working across more than 60 institutions around the world. Our four-year project brings together interdisciplinary and scientific research, cultural heritage preservation, community relationship-building, and the development of knowledge-sharing tools, protocols, and best practices. \nWebsite: https://hiddenstories.library.utoronto.ca/',
            skills: [
                'PHP', 'Omeka', 'MySQL', 'JavaScript', 'jQuery', 'TailwindCss'
            ],
            cover_img: 'assets/images/projects/cover/hidden-stories.png',
            assets: [
                {
                    type: 'image',
                    path: 'assets/images/projects/hidden-stories/01_home_page_1.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/hidden-stories/02_home_page_2.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/hidden-stories/03_people_page.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/hidden-stories/04_research_page.png'
                },
            ]
        },
        {
            name: 'University of Toronto Libraries - Digital Collections',
            description: 'The Digital Collections project aims to provide a centralized repository for the University of Toronto Libraries’ digital collections. The project will focus on developing a user-friendly interface for searching, browsing, and accessing digital collections, as well as enhancing the existing collection management system. \nWebsite: https://collections.library.utoronto.ca/',
            skills: [
                'Next.js', 'GraphQL', 'MarkLogic', 'TailwindCss'
            ],
            cover_img: 'assets/images/projects/cover/digital-collections.png',
            assets: [
                {
                    type: 'image',
                    path: 'assets/images/projects/digital-collections/01_home_page.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/digital-collections/02_repository_page.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/digital-collections/03_repository_list.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/digital-collections/04_collection_item_list.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/digital-collections/05_collection_item_page.png'
                },
            ]
        },
        {
            name: 'Hong Kong Science Festival 2023',
            description: 'A virtual exhibition website. The exhibitors can upload their booth info and streaming, so the guests can join this festival virtually.',
            skills: [
                'Laravel', 'Livewire', 'Javascript', 'TailwindCss'
            ],
            cover_img: 'assets/images/projects/cover/scifest.png',
            assets: [
                {
                    type: 'image',
                    path: 'assets/images/projects/scifest/activity_detail.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/scifest/activity_edit.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/scifest/activity_index.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/scifest/booth_detail_1.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/scifest/booth_design.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/scifest/intro.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/scifest/lobby.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/scifest/login.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/scifest/reward.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/scifest/webinar_detail.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/scifest/webinar_index.png'
                }
            ]
        },
        {
            name: 'Faceswap',
            description: 'Faceswap is an AI-based tool that lets users swap faces with others or portraits, like oil paintings, for an immersive event experience.',
            skills: [
                'OpenCV', 'Python'
            ],
            cover_img: 'assets/images/projects/cover/faceswap.jpg',
            assets: [
                {
                    type: 'image',
                    path: 'assets/images/projects/faceswap/01_demo.jpg'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/faceswap/02_demo.jpg'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/faceswap/03_demo.jpg'
                },                
                {
                    type: 'image',
                    path: 'assets/images/projects/faceswap/04_demo.jpg'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/faceswap/05_demo.jpg'
                }
            ]
        },
        {
            name: 'Virtually Versailles',
            description: 'The app designed for the French May event is designed to allow tourists to have an immersive experience, combining AR interaction, hologram, 360 images and other technologies, so that everyone can understand of France and its art with fun.',
            skills: [
                'React Native', 'Node.js', 'Express.js', 'MongoDB'
            ],
            cover_img: 'assets/images/projects/cover/frenchmay.png',
            assets: [
                {
                    type: 'youtube',
                    youtube_id: 'EdNIHr3C5r0',
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/frenchmay/IMG_7316.PNG'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/frenchmay/IMG_7317.PNG'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/frenchmay/IMG_7318.PNG'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/frenchmay/IMG_7319.PNG'
                },                
                {
                    type: 'image',
                    path: 'assets/images/projects/frenchmay/IMG_7320.PNG'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/frenchmay/IMG_7321.PNG'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/frenchmay/IMG_7322.PNG'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/frenchmay/IMG_7323.PNG'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/frenchmay/IMG_7324.PNG'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/frenchmay/IMG_7325.PNG'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/frenchmay/IMG_7326.PNG'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/frenchmay/IMG_7327.PNG'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/frenchmay/IMG_7328.PNG'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/frenchmay/IMG_7329.PNG'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/frenchmay/IMG_7330.PNG'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/frenchmay/IMG_7331.PNG'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/frenchmay/IMG_7332.PNG'
                }
            ]
        },
        {
            name: 'i-CREATe Virtual Exhibition',
            description: 'A virtual exhibition website. The exhibitors can upload their booth info and streaming, so the guests can join this festival virtually.',
            skills: [
                'Laravel', 'Livewire', 'Javascript', 'TailwindCss'
            ],
            cover_img: 'assets/images/projects/cover/i-create.png',
            assets: [
                {
                    type: 'image',
                    path: 'assets/images/projects/i-create/00_lobby.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/i-create/01_appointment.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/i-create/02_gsic_edit.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/i-create/03_poster_edit.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/i-create/04_booth_index.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/i-create/05_booth_detail.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/i-create/06_gsic_index.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/i-create/07_webinar_date.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/i-create/08_webinar_view_1.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/i-create/09_webinar_view_2.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/i-create/10_webinar_view_3.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/i-create/11_webinar_view_4.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/i-create/12_webinar_view_5.png'                    
                },
            ]
        },
        {
            name: 'E-Signature Wall',
            description: 'Sign the signature on iPad, and display the signature on the screen.',
            skills: [
                'Laravel', 'Javascript', 'CSS'
            ],
            cover_img: 'assets/images/projects/cover/e-signature.png',
            assets: [
                {
                    type: 'image',
                    path: 'assets/images/projects/e-signature/00_e-signature.png'
                },
                {
                    type: 'video',
                    path: 'assets/images/projects/e-signature/01_e-signature.mp4'
                }
            ]
        },
        {
            name: 'Coiner App',
            description: 'An app to store member point and browse information.',
            skills: [
                'React Native', 'Node.js', 'Express.js', 'MongoDB'
            ],
            cover_img: 'assets/images/projects/cover/coiner.png',
            assets: [
                {
                    type: 'image',
                    path: 'assets/images/projects/coiner/IMG_7301.PNG'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/coiner/IMG_7302.PNG'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/coiner/IMG_7303.PNG'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/coiner/IMG_7304.PNG'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/coiner/IMG_7305.PNG'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/coiner/IMG_7306.PNG'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/coiner/IMG_7307.PNG'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/coiner/IMG_7308.PNG'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/coiner/IMG_7309.PNG'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/coiner/IMG_7310.PNG'                    
                }
            ]
        },
        {
            name: 'iTrain B2B2C Convertion',
            description: 'Convert e-learning platform into B2C / B2B2C model, and revamp the UI of the whole system.',
            skills: [
                'Angular', 'Laravel'
            ],
            cover_img: 'assets/images/projects/cover/itrain.png',
            assets: [
                {
                    type: 'youtube',
                    youtube_id: 'pigTNV_SNDA',
                },
                {
                    type: 'youtube',
                    youtube_id: 'zbTLx5nQJ8Y',
                }
            ]
        },
        {
            name: 'File Picker Component',
            description: 'A file picker component using Augular, which is allowing multi-select, adjust, preview function.',
            skills: [
                'Angular'
            ],
            cover_img: 'assets/images/projects/cover/filepicker.png',
            assets: [
                {
                    type: 'youtube',
                    youtube_id: '25gmRKZuBFc',
                }
            ]
        },
        {
            name: 'Masksapp',
            description: 'Share mask information at the begining of COVID-19',
            skills: [
                'Android Studio', 'Java', 'Firebase'
            ],
            cover_img: 'assets/images/projects/cover/masksapp.png',
            assets: [
                {
                    type: 'youtube',
                    youtube_id: '2d5Q1Nvd01U',
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/masksapp/01_home.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/masksapp/01_mask_detail.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/masksapp/03_comment.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/masksapp/04_intelligence.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/masksapp/05_view_comment.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/masksapp/06_view_intelligence.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/masksapp/07_location.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/masksapp/08_create_mask.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/masksapp/09_create_trade.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/masksapp/10_trade_detail.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/masksapp/11_trade.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/masksapp/12_login.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/masksapp/13_singup.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/masksapp/14_account.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/masksapp/15_blog.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/masksapp/16_blog_detail.png'  
                }
            ]
        },
        {
            name: 'Low Cost Book Tracking System Prototype',
            description: 'Using RFID technology to real time track book, we build a prototype with a simple library management system and Android App for the staff.',
            skills: [
                'RFID', 'Laravel', 'Android Studio', 'Java', 'C++'
            ],
            cover_img: 'assets/images/projects/cover/book-tracking.png',
            assets: [
                {
                    type: 'youtube',
                    youtube_id: 'O1yaCYtzeJs',
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/book-tracking/01_web_manage_book.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/book-tracking/02_web_search_book.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/book-tracking/03_web_bookDetails.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/book-tracking/04_web_track_book.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/book-tracking/05_web_AllReaderResult.jpg'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/book-tracking/10_app_main.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/book-tracking/11_app_search.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/book-tracking/12_app_track.png'
                },
                {
                    type: 'image',
                    path: 'assets/images/projects/book-tracking/20_hardward.png'
                },
            ]
        }
    ]
}

export default InfoData;